export default {
      id: "check2-usage",
      viewBox: "0 0 11.502 8.002",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#check2",
      toString: function () {
        return this.url;
      }
    }